export const enum MUTATIONS {
  SEARCH = 'SEARCH',
  DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
  LOGIN_NOTIFICATION = 'LOGIN_NOTIFICATION',
  LOGOUT_NOTIFICATION = 'LOGOUT_NOTIFICATION',
  SESSION_TIMEOUT_NOTIFICATION = 'SESSION_TIMEOUT_NOTIFICATION'
}
